export default class BaseApiService {
  ENDPOINTS = {
    request: {
      shared: {
        queue: "/api/applications/get-applications",
        queue_with_pagination: "api/applications/get-applications/v2",
        dependencies: "/api/applications/get-form-dependencies",
        request:
          "/api/applications/get-application?include=attachments,advance_payments,cost_lines,travel_intervals,locks,onholds,food_equivalent,final_settlement",
        submit: "/api/applications/submit",
        update: "/api/applications/update",
        accept: "/api/applications/accept",
        reject: "/api/applications/reject",
        cancel: "/api/applications/cancel",
        lock: "/api/applications/lock",
        create: "/api/applications",
        request_search: "/api/applications/get-application",
      },
      card: {
        request: "/api/applications/credit-card",
        queue: "/api/applications/credit-card/get-applications",
        update: "/api/applications/credit-card/update",
      },
    },
    internal_orders: "/api/internal-orders/get-by-actor-type",
    local_admin: {
      companies: "/api/local-admin/companies",
      credit_cards: {
        upload_statement: "/api/local-admin/credit-cards/upload-statement",
        card_holders: {
          rud: "/api/local-admin/credit-cards/card-holders",
          create: "/api/local-admin/credit-cards/card-holders/store",
        },
        request_history: {
          applications_by_dates:
            "/api/local-admin/credit-cards/request-history/get-applications-by-dates",
          applications_reports_by_dates:
            "/api/local-admin/credit-cards/request-history/get-applications-report-by-dates",
          uploads: "/api/local-admin/credit-cards/request-history/get-uploads",
        },
        costs_audit: {
          costs_by_dates:
            "/api/local-admin/credit-cards/request-history/get-costs-by-dates",
          costs_report_by_dates:
            "/api/local-admin/credit-cards/request-history/get-costs-report-by-dates",
        },
      },
    },
    a1: {
      queue: "/api/AOne",
      details: "/api/AOne/details",
      reject: "/api/AOne/reject",
      accept: "/api/AOne/accept",
      create: "/api/AOne/create",
    },
    accounts_payable: {
      advance_payments: {
        queue: "/api/accounts-payable/advance-payments/get-advance-payments",
        generate_sap_export:
          "/api/accounts-payable/advance-payments/generate-sap-export",
      },
      queues: {
        common: "/api/accounts-payable/applications/get-applications",
        employee:
          "/api/accounts-payable/applications/get-employee-applications",
        historical:
          "/api/accounts-payable/applications/get-historical-applications",
      },
      reasons_of_rejection: "/api/accounts-payable/get-rejection-reasons",
      calculate_final_settlement:
        "/api/accounts-payable/final-settlement/calculate",
      generate_sap_export_preview:
        "/api/accounts-payable/sap-exports/generate-sap-export-preview",
      generate_sap_export:
        "/api/accounts-payable/applications/generate-sap-export",
      confirm_sap_export:
        "/api/accounts-payable/sap-exports/confirm-sap-export",
      on_hold: "/api/accounts-payable/applications/on-hold",
    },
    cost_line: {
      entity: "/api/cost-lines",
      update: "/api/cost-lines/update",
      accept: "/api/cost-lines/accept",
      reject: "/api/cost-lines/reject",
    },
    meals_calendar: {
      days: "/api/meals/",
      dependencies: "/api/meals/data/",
      store: "/api/meals/store",
    },
    vehicles: {
      crud: "/api/vehicles/my-vehicles",
      types: "/api/vehicles/types",
    },
    travel_line: {
      crud: "/api/travel-intervals",
    },
    user: {
      profile: "/api/users/my-profile?include=roles,vehicles",
      update: "/api/users/my-profile",
    },
    auth: {
      csrf_cookie: "/api/csrf-cookie",
      realm_login: "/api/auth/realm-login",
      realm_login_confirm: "/api/auth/realm-login-confirm",
      realm_logout: "/api/auth/realm-logout",
      realm_logout_confirm: "/api/auth/realm-logout-confirm",
    },
    cwt: {
      update: "/api/administration/cwt/update",
      booking: {
        crud: "/api/travel-declarations/cwt",
      },
    },
    estimated_travel_costs: {
      create: "api/travel-cost",
      update: "api/travel-cost/update",
    },
    estimated_emission: {
      create: "api/carbon-dioxide-emission",
      update: "api/carbon-dioxide-emission/update",
    },
    attachments: {
      store: "/api/attachments/store",
      ocr: {
        store: "/api/attachments/ocr/store",
      },
    },
    google_search: {
      travel_places: "/api/travel-places/find",
    },
    logs: {
      write: "/api/logs/write",
    },
    available_modules: "/api/get-available-modules",
    tester_panel: {
      data: "/api/tester-role/get-my-data-summary",
      companies: "/api/tester-role/get-available-companies",
      update_data: "/api/tester-role/update-tester-data",
    },
    currency: "/api/currency-module/calculate",
  };
}
